import { Trans } from '@lingui/react/macro';

import { SkeletonRectangle } from '@/components/loaders';
import {
  Progress,
  ProgressGoal,
  ProgressGoalIndicator,
  ProgressGoalLabel,
  ProgressIndicator,
  ProgressTrack,
} from '@/components/Progress';
import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

type Props = {
  isLoading: boolean;
  value?: number;
};

const OnboardingProgressBar = ({ isLoading, value }: Props) => {
  value = isLoading || !value ? 0 : Math.floor(value * 100) / 100;
  const valuePercentNumber = Math.floor(value * 100);
  const valuePercent = `${valuePercentNumber}%`;

  return (
    <div className="flex h-full flex-col pt-1.5 pb-8.5">
      {isLoading ? (
        <SkeletonRectangle width="100%" height={35} />
      ) : (
        <Progress value={valuePercentNumber}>
          <ProgressTrack className="h-8 bg-gray-100">
            <ProgressIndicator
              data-testid="onboarding-progress-bar"
              className={cn(
                value < 0.6 && 'bg-red-400',
                value >= 0.6 && value < 0.8 && 'bg-yellow-300',
                value >= 0.8 && 'bg-green-400',
              )}
            />
            {value < 1 && (
              <Text
                className="absolute left-0 pl-3"
                variant="caption2"
                style={{ left: valuePercent }}
              >
                {valuePercent}
              </Text>
            )}
            <ProgressGoal value={100}>
              <ProgressGoalIndicator orientation="below" />
              <ProgressGoalLabel orientation="below">
                <Trans>100% Complete</Trans>
              </ProgressGoalLabel>
            </ProgressGoal>
          </ProgressTrack>
        </Progress>
      )}
    </div>
  );
};

export default OnboardingProgressBar;
